import { Icon, IconButton, Stack } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { ActiveStatusFilter } from '../../_components/table/activeStatus.filter';
import { SearchTableHeader } from '../../_components/table/search.table';
import { PaperTableHeader } from '../../_components/table/header.table';
import { StandardTable } from '../../_components/table/standard.table';
import { TABLE_FILTER } from '../../_const/tableFilter.const';
import { handleErrorResponse } from '../../_helpers/handleResponse.helper';
import { usersService } from '../../_services/users.service';
import { UsersManageDrawer } from './users-manage';

export function UsersIndex() {
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const [filter, setFilter] = useState<any>({ ...TABLE_FILTER, isActive: true});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const fetchData = async () => {
        setIsLoading(true);
        return await usersService.getAll(filter)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            })
    };

    useEffect(() => {
        fetchData();
    }, [filter]);

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: 'Actions',
                size: 80,
                enableSorting: false,
                enableColumnFilter: false,
                Cell: ({ row }) => (
                    <IconButton
                        color="primary"
                        onClick={() => { navigate("Manage/" + row.original.id) }}>
                        <Icon>edit</Icon>
                    </IconButton>
                ),
            },
            {
                accessorKey: 'id',
                header: 'ID',
            },
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'email',
                header: 'Email',
            },
            {
                accessorKey: 'status',
                header: 'Status',
                enableColumnFilter: false,
            },
        ],
        []
    );

    // const statusSelectValue = filter.isActive === true ? "true" : filter.isActive === false ? "false" : "";

    return (
        <>
            <PaperTableHeader title="Users" buttons={[
                { icon: "add", label: "Create", onClick: () => { navigate("Create") } }
            ]} />

            <Stack direction="row" spacing={2} sx={{ mb: 2, marginTop: "16px", alignItems: "flex-start" }}>
                <SearchTableHeader noMargin inputs={[
                    { label: "Name", name: "name", onChange: setFilter, value: filter.name },
                    { label: "Email", name: "email", onChange: setFilter, value: filter.email },
                ]} />
                <ActiveStatusFilter value={filter.isActive} onChange={setFilter} />
            </Stack>

            <StandardTable
                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
            />

            <Routes>
                <Route path="Create" element={<UsersManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
                <Route path="Manage/:id" element={<UsersManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
            </Routes>

        </>
    );
}
